// Persists light/dark preference to localStorage.
import { useState, useCallback } from "react";
import type { PaletteMode } from "@mui/material";

const KEY = "dashboard-color-mode";

function getInitialMode(): PaletteMode {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    // localStorage unavailable
  }
  // Default to dark — matches VS Code default and the design target
  return "dark";
}

export function useColorMode(): [PaletteMode, () => void] {
  const [mode, setMode] = useState<PaletteMode>(getInitialMode);

  const toggle = useCallback(() => {
    setMode((prev) => {
      const next: PaletteMode = prev === "dark" ? "light" : "dark";
      try {
        localStorage.setItem(KEY, next);
      } catch {
        // ignore
      }
      return next;
    });
  }, []);

  return [mode, toggle];
}
